import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './EmbeddedImage.scss';
import { ConditionalWrapper } from '../../shared/ConditionalWrapper';
import { processLink } from '../../shared/processLink';
import { SmartLink } from '../SmartLink/SmartLink';

export const EmbeddedImage = ({ node, forceInline }) => {
    const { field_link_single: mediaLink } = node;

    const alternativeText: string = node.relationships?.field_media
        ?.field_media_image?.alt
        ? node.relationships?.field_media?.field_media_image?.alt
        : ``;

    return (
        <figure
            className={`embedded-image themed-container ${
                node.field_theme ? node.field_theme : ``
            }`}
        >
            <div className={`${forceInline ? `inline` : `kite-container`}`}>
                <ConditionalWrapper
                    condition={mediaLink?.uri}
                    wrapper={(children) => (
                        <SmartLink
                            className={`conditional-wrapper`}
                            href={processLink(mediaLink.uri)}
                            aria-label={alternativeText}
                        >
                            {children}
                        </SmartLink>
                    )}
                >
                    <GatsbyImage
                        image={getImage(
                            node.relationships?.field_media?.relationships
                                ?.field_media_image?.localFile
                        )}
                        alt={alternativeText}
                    />
                </ConditionalWrapper>
                {node.field_subtitle && (
                    <figcaption>{node.field_subtitle}</figcaption>
                )}
            </div>
        </figure>
    );
};
